import { GeneralModel } from "./general.model";

export class KPIShipmentDetailModel extends GeneralModel {
    provinceName: any;
    districtName: any;
    wardName: any;
    districtId: any;
    wardId: any;
    vehicle: any;
    targetDeliveryTime: number;
    kpiShipmentId: number;
    TargetPaymentCOD: any;
}